import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import { paths } from "src/routes/paths";

export const stateDataSource = [
  { value: 0, text: "auditDeleted" },
  { value: 1, text: "auditModified" },
  { value: 2, text: "auditAdded" },
  { value: 3, text: "auditSessionStarted" },
  { value: 4, text: "auditSessionClosed" },
  { value: 5, text: "auditSessionFailed" },
];

export function buildStateText(rowData, includeInfo, t) {
  let caption = "";

  switch (rowData.state) {
    case 0:
      caption = t("auditDeleted");
      break;
    case 1:
      caption = t("auditModified");
      break;
    case 2:
      caption = t("auditAdded");
      break;
    case 3:
      caption = t("auditSessionStarted");
      break;
    case 4:
      caption = t("auditSessionClosed");
      break;
    case 5:
      caption = t("auditSessionFailed");
      break;
    default:
      caption = "";
  }

  if (includeInfo && rowData.stateInfo === "HardDeleted") caption += ` (${t("permanently")})`;

  return caption;
}

export function buildLink(rowData, label) {
  const referencingTable = rowData.entityName[0].toLowerCase() + rowData.entityName.substring(1);
  const path = paths.dashboard[referencingTable];

  if (path && path.edit) {
    return <Link href={path.edit(rowData.entityId)}>{label || rowData.entityId}</Link>;
  }

  return label || rowData.entityId;
}

export function buildUserText(user, t) {
  return user ?? t("system");
}
